var Scroll = require('react-scroll');
var scroller = Scroll.animateScroll;

export const scrollTo = (pos: number) => {
    if (pos > 0) {
        scroller.scrollTo(pos);
    } else {
        scroller.scrollToBottom({
            smooth: true
        });
    }
};

const PageScrollingHelper = { scrollTo };
export default PageScrollingHelper;
